export const CATEGORY_LABELS: Record<string, string> = {
    'arq': 'CATEGORIES.ARQ',
    'natural': 'CATEGORIES.NATURAL',
    'evento': 'CATEGORIES.EVENTO',
    'sendero': 'CATEGORIES.SENDERO',
    'pueblo': 'CATEGORIES.PUEBLO',
    'playa': 'CATEGORIES.PLAYA',
    'alo': 'CATEGORIES.ALO',
    'alojamiento': 'CATEGORIES.ALO',
};

export const CATEGORY_SLOGANS: Record<string, string> = {
    'playa': 'SLOGANS.PLAYA',
    'pueblo': 'SLOGANS.PUEBLO',
    'arq': 'SLOGANS.ARQ',
    'sendero': 'SLOGANS.SENDERO',
    'alojamiento': 'SLOGANS.ALOJAMIENTO',
    'evento': 'SLOGANS.EVENTO',
    'natural': 'SLOGANS.NATURAL'
};

export const CATEGORY_ICONS: Record<string, string> = {
    'arq': 'arquitectura',
    'natural': 'naturaleza',
    'evento': 'eventos',
    'sendero': 'senderos',
    'pueblo': 'pueblos',
    'playa': 'playas',
    'alo': 'alo',
    'alojamiento': 'alojamiento',

};

export function getCategorySlogan(code: string): string {
    return CATEGORY_SLOGANS[code?.toLowerCase()] || '';
}

export function getCategoryLabel(code: string): string {
    return CATEGORY_LABELS[code?.toLowerCase()] || code;
}

export function getCategoryIcon(code: string): string {
    return CATEGORY_ICONS[code?.toLowerCase()] || code;
}